// extracted by mini-css-extract-plugin
export var select = "_qk-0";